// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_gnP","cls2":"TranslationModal-cls2__to TranslationModal-cls1_gnP"};